import { Styled } from '.';
import { useI18n } from 'contexts/i18n';

const ExpiredText = () => {
  const i18n = useI18n();
  return (
    <Styled.ExpiredText>{i18n['Flash Sale offer expired']}</Styled.ExpiredText>
  );
};

export default ExpiredText;
